const getPagePath = () => {
  if (typeof window === 'undefined') return undefined

  return `${window.location.pathname}${window.location.search}`
}

export const trackGa4Event = (eventName, parameters = {}) => {
  if (
    typeof window === 'undefined' ||
    typeof window.gtag !== 'function' ||
    !eventName
  ) {
    return
  }

  window.gtag('event', eventName, {
    page_path: getPagePath(),
    ...parameters,
  })
}

export const trackLeadSubmission = ({ eventName, formName, formProvider }) => {
  const parameters = {
    form_name: formName,
    form_provider: formProvider,
  }

  trackGa4Event('generate_lead', parameters)

  if (eventName && eventName !== 'generate_lead') {
    trackGa4Event(eventName, parameters)
  }
}

export const getLeadEventForPath = (path) => {
  if (!path) return undefined
  if (path.includes('3d-scanning')) return 'get_3d_scanning_quote'
  if (path.includes('laser-cutting') || path.includes('laser-engraving')) {
    return 'submitted_laser_cutting_form'
  }
  if (path.includes('3d-modeling')) return 'submitted_3d_modeling_form'
  if (
    path.includes('custom-trophy') ||
    path.includes('custom-award') ||
    path.includes('corporate-award')
  ) {
    return 'get_custom_trophy_quote'
  }
  if (path.includes('art-fabrication') || path.includes('sculpture')) {
    return 'get_art_fabrication_quote'
  }
  if (
    path.includes('3d-printing') ||
    path.includes('full-color-3d') ||
    path.includes('large-scale-3d')
  ) {
    return 'get_3d_printing_quote'
  }

  return undefined
}
